import React, { useCallback, useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import ButtonPrimary from "../ButtonPrimary";
import { InputModal } from "../InputModal";
import {
  AvatarContainer,
  Box,
  BoxColor,
  Button,
  ButtonBack,
  ButtonShared,
  ContainerModal,
  FlexInput,
  HorizontalStack,
  HStack,
  HStackBtn,
  InputBase,
  InputHex,
  Line,
  NameContainer,
  ProfileUser,
  Text,
  TextArea,
  Title,
  VerticalStack,
  Wrapper,
  WrapperProfileShared
} from "./styles";
import { AnimatePresence, motion } from "framer-motion";
import api from "../../../../services/api";
import { useModalContext } from "../../../../hooks/modalContext";
import { useSelection } from "../../hooks/selection";
import LetterAvatar from "../../../master/components/LetterAvatar";
import MultiplesAvatarLetter from "../../../master/components/MultiplesAvatarLetter";
import { useMainHook } from "../../../../hooks/main";
import { useSharedDocument } from "../../hooks/sharedDocument";
import { useNavigate, useParams } from "react-router-dom";
import { ButtonDeleteUserShared } from "../ModalSharedDocument/styles";
import IconSvg from "../IconSvg";
import deleteIcon from "../../assets/deleteIcon.svg";
import { getColors } from "../../utils/getColorAvatar";
import LoadingEditor from "../LoadingEditor";
import { StageContainer } from "../ModalVersioning/styles";
import { Layer, Stage } from "react-konva";
import Konva from "konva";
import Rendering from "../Canvas/Rendering";
import { useToolbarEditor } from "../../hooks/toolbarEditor";
import iconClosePreviewMode from "../../assets/closePreview-icon.svg";
import { ContainerLoading } from "../LoadingEditor/styles";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";
import { useTextsEdition } from "../../hooks/textsEdition";
import { useDiff } from "../../hooks/diffDocuments";

interface UsersSharedProps {
  id: string;
  name: string;
  email: string;
  avatar_url: string;
  permissions: "Owner" | "Editor" | string;
  is_anonymous: boolean;
  current_user: boolean;
}

interface UserAccessControlProps {
  access_control: boolean;
  user_list: UsersSharedProps[];
}

interface ModalActiveUserProps {
  isOpen: boolean;
  onRequestClose?: () => void;
  dataUsers?: UserAccessControlProps;
}

export const ModalActiveUser: React.FC<ModalActiveUserProps> = ({
  isOpen,
  onRequestClose,
  dataUsers
}) => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      scale: 1.2,
      transition: {
        delayChildren: 0.5,
        type: "spring",
        duration: 1,
        stiffness: 100,
        staggerDirection: -1
      }
    }
  };

  const item = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 1.9,
        type: "spring",
        stiffness: 100
      }
    }
  };

  const oneRef = useRef(null);
  const oldPos = useRef(null);
  const selectionRectRef = useRef(null);
  const layerRef = useRef(null);
  const selection = useRef({
    visible: false,
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  });

  const [previewMode, setPreviewMode] = useState(false);
  const {
    objectScreen,
    addToRefs,
    setSelectedGroup,
    addToHistory,
    setObjectScreen,
    currentTemplateInfo,
    myProfileId,
    nameOfCurrentUser
  } = useMainHook();
  const { templateid } = useParams();
  const [loading, setLoading] = useState(true);
  const {
    setSelectedObject,
    addToMultipleSelectionRef,
    multipleSelectionRefs,
    currentMultipleSelection,

    selectedObject,
    transformerSelectedObject,

    setSelectedObjects
  } = useSelection();

  const {
    quillRef,
    requestTextUpdate,
    textRich,
    isEditing,
    setIsEditing,
    blockingKeyboard,
    setBlockingKeyboard,
    quillRefComponent
  } = useTextsEdition();

  const {
    templateStartedShared,
    setTemplateStartedShared,
    oldContentsState,
    setOldContentsState,
    newContentsState,
    setNewContentsState,
    selectionCursor,
    setSelectionCursor,
    findDiff,
    buttonRef,
    newDelta,
    setNewDelta,
    isEditingQuill,
    setIsEditingQuill,
    newChanges,
    setNewChanges,
    newContentsRef,
    oldContentsRef,
    getQuillCursorRef,
    isNewTextRef,
    isTypingQuillRef,
    whichUserEdited,
    interceptModifications,
    textIsChanged,
    blockRenderImage,
    blockBackspace,
    hasGroupShared,
    whichKeyPress,
    selectionFormatText
  } = useDiff();

  const { blockCommandKeyboard, setBlockCommandKeyboard } = useToolbarEditor();
  const [sharedUsers, setSharedUsers] = useState<UsersSharedProps[]>([]);
  const {
    refreshUsersShared,
    setRefreshUsersShared,
    isModalActiveUser,
    setIsModalActiveUser
  } = useSharedDocument();
  const [isOwnerDocument, setIsOwnerDocument] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  const navigate = useNavigate();

  const widthCanvas: number = 596;
  const heigthCanvas: number = 842;

  useEffect(() => {
    if (dataUsers.access_control === true) {
      setIsModalActiveUser(false);
    } else {
      return;
    }
  }, [dataUsers]);

  useEffect(() => {
    const autoLoadSharedUsers = async () => {
      try {
        const responseTemplatesUsers = await api.get(
          `user-share-template/all-shared-template-users/${templateid}`
        );
        setSharedUsers(responseTemplatesUsers.data.users);
      } catch (err) {
        console.log(err, "ERROR when fetch users shared template");
      }
    };

    autoLoadSharedUsers();
  }, [refreshUsersShared]);

  const handleDeleteUserShare = useCallback(
    async idUser => {
      let userId = idUser;
      let documentId = templateid;

      try {
        const responseDeleteUserShare = await api.delete(
          `user-share-template/delete-user-share/${userId}/${documentId}`
        );

        setRefreshUsersShared(!refreshUsersShared);
      } catch (err) {
        console.log(err, "ERROR when delete user shared");
      }
    },
    [refreshUsersShared]
  );

  // useEffect(() => {
  //   setTimeout(() => {
  //     setForceUpdate(!forceUpdate);
  //   }, 2000);
  // }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (myProfileId) {
      const getOwnerId = sharedUsers.find(user => user.permissions === "Owner");

      if (getOwnerId?.id === myProfileId) {
        setIsOwnerDocument(true);
      } else {
        setIsOwnerDocument(false);
      }
    }
  }, [forceUpdate]);

  if (loading) {
    return (
      <div className="loading-application">
        <ContainerLoading>
          {/* <LoadingEditor /> */}
          <ContractAnimation />
        </ContainerLoading>
      </div>
    );
  }

  const windows = window as any;
  const Konvas = windows.Konva;

  const updateSelectionRect = () => {
    const node = selectionRectRef.current;
    node?.setAttrs({
      visible: selection.current.visible,
      x: Math.min(selection.current.x1, selection.current.x2),
      y: Math.min(selection.current.y1, selection.current.y2),
      width: Math.abs(selection.current.x1 - selection.current.x2),
      height: Math.abs(selection.current.y1 - selection.current.y2),
      fill: "rgba(140, 161, 255, 0.3)"
    });
    node.getLayer().batchDraw();
  };

  const onMouseDown = e => {
    if (e.target instanceof Konva.Stage) {
      setSelectedObject(null);

      // cleaning currentMutipleSelection
      if (currentMultipleSelection.current) {
        currentMultipleSelection.current.setNodes([]);
        setSelectedObjects([]);
      }

      const pos = e.target.getStage().getPointerPosition();
      selection.current.visible = true;
      selection.current.x1 = pos.x;
      selection.current.y1 = pos.y;
      selection.current.x2 = pos.x;
      selection.current.y2 = pos.y;
      updateSelectionRect();
      return;
    }
  };

  const onMouseMove = e => {
    if (!selection.current.visible) {
      return;
    }

    const pos = e.target.getStage().getPointerPosition();
    selection.current.x2 = pos.x;
    selection.current.y2 = pos.y;
    updateSelectionRect();
  };

  const onMouseUp = event => {
    //assigning currentMutipleSelection to the multpleSelection in the stage with it's index

    const currentIndex = event.currentTarget.attrs.id - 1;
    currentMultipleSelection.current =
      multipleSelectionRefs.current[currentIndex];

    oldPos.current = null;
    if (!selection.current.visible) {
      return;
    }
    // getting properties of selectionRect
    const selBox = selectionRectRef.current.getClientRect();

    const elements = [];

    layerRef.current.children.forEach((elementNode, index) => {
      if (
        elementNode !== currentMultipleSelection.current &&
        elementNode !== selectionRectRef.current
      ) {
        const elBox = elementNode.getClientRect();

        if (Konva.Util.haveIntersection(selBox, elBox)) {
          elements.push(elementNode);
        }
      }
    });

    currentMultipleSelection.current.setNodes(elements);
    setSelectedObjects(elements);

    selection.current.visible = false;
    updateSelectionRect();
  };

  return (
    <>
      {dataUsers && (
        <Modal
          className="react-modal-content2"
          overlayClassName={
            previewMode
              ? "react-modal-overlay2"
              : "react-modal-overlay-without-preview"
          }
          isOpen={isOpen}
          onRequestClose={onRequestClose}
          ariaHideApp={false}
        >
          {previewMode && (
            <button
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer"
              }}
              onClick={() => setPreviewMode(state => !state)}
            >
              <IconSvg
                className="close-button-preview-mode"
                src={iconClosePreviewMode}
                description=""
              />
            </button>
          )}

          <AnimatePresence>
            {previewMode ? (
              <VerticalStack>
                {objectScreen.map((item, index) => (
                  <StageContainer as={motion.div}>
                    <Stage
                      ref={oneRef}
                      listening={false}
                      onClick={() => console.log("")}
                      pixelRatio={5}
                      scaleX={1}
                      scaleY={1}
                      width={widthCanvas}
                      height={heigthCanvas}
                    >
                      <Layer>
                        {item.renderObjects.map((objectProps, index) => (
                          <Rendering
                            key={String(Math.random() * index)}
                            selectedObject={selectedObject}
                            setSelectedObject={setSelectedObject}
                            objectProps={objectProps}
                            addToHistory={addToHistory}
                            commandKeyboard={blockCommandKeyboard}
                            setCommandBlockKeyboard={setBlockCommandKeyboard}
                            currentMultipleSelection={currentMultipleSelection}
                            setObjectScreen={setObjectScreen}
                            transformerSelectedObject={
                              transformerSelectedObject
                            }
                            quillRef={quillRef}
                            requestUpdateText={requestTextUpdate}
                            textRich={textRich}
                            isEditing={isEditing}
                            setIsEditing={setIsEditing}
                            blockingKeyboard={blockingKeyboard}
                            setBlockingKeyboard={setBlockingKeyboard}
                            templateStartedShared={templateStartedShared}
                            setTemplateStartedShared={setTemplateStartedShared}
                            oldContentsState={oldContentsState}
                            setOldContentsState={setOldContentsState}
                            newContentsState={newContentsState}
                            setNewContentsState={setNewContentsState}
                            selectionCursor={selectionCursor}
                            setSelectionCursor={setSelectionCursor}
                            findDiff={findDiff}
                            buttonRef={buttonRef}
                            newDelta={newDelta}
                            setNewDelta={setNewDelta}
                            isEditingQuill={isEditingQuill}
                            setIsEditingQuill={setIsEditingQuill}
                            newChanges={newChanges}
                            setNewChanges={setNewChanges}
                            oldContentsRef={oldContentsRef}
                            newContentsRef={newContentsRef}
                            getQuillCursorRef={getQuillCursorRef}
                            isNewTextRef={isNewTextRef}
                            isTypingQuillRef={isTypingQuillRef}
                            quillRefComponent={quillRefComponent}
                            whichUserEdited={whichUserEdited}
                            nameOfCurrentUser={nameOfCurrentUser}
                            interceptModifications={interceptModifications}
                            textIsChanged={textIsChanged}
                            blockRenderImage={blockRenderImage}
                            blockBackspace={blockBackspace}
                            hasGroupShared={hasGroupShared}
                            whichKeyPress={whichKeyPress}
                            selectionFormatText={selectionFormatText}
                          />
                        ))}
                      </Layer>
                    </Stage>
                  </StageContainer>
                ))}
              </VerticalStack>
            ) : (
              <ContainerModal
                as={motion.form}
                initial="hidden"
                animate="show"
                variants={container}
                exit={{
                  opacity: 0,
                  scale: 0.8,
                  x: -300
                }}
                transition={{ duration: 1 }}
              >
                <Title>
                  Compartilhado - {currentTemplateInfo?.current?.title}
                </Title>
                <Line />

                <VerticalStack>
                  {dataUsers.user_list?.map((user, index) => (
                    <WrapperProfileShared key={user.id}>
                      <AvatarContainer>
                        <MultiplesAvatarLetter
                          src={user.avatar_url}
                          text={user.name}
                          color={getColors()}
                          isAnnonymous={user.is_anonymous}
                        />
                      </AvatarContainer>
                      <NameContainer>
                        <ProfileUser>
                          {`${user.name} `}
                          {user.permissions === "Owner" ? (
                            <span style={{ marginLeft: "0.4rem" }}>
                              (proprietário)
                            </span>
                          ) : (
                            ""
                          )}
                        </ProfileUser>
                      </NameContainer>

                      {user.current_user && (
                        <div className="active-user">Ativo</div>
                      )}
                    </WrapperProfileShared>
                  ))}
                </VerticalStack>
                <Text>
                  O documento está sendo editado no momento. Clique no botão
                  “visualizar” para ver o documento.
                </Text>

                <Wrapper>
                  <ButtonShared
                    style={{ marginRight: "2rem" }}
                    onClick={() => setPreviewMode(prevState => !prevState)}
                  >
                    Visualizar
                  </ButtonShared>
                  <ButtonShared onClick={() => navigate("/")}>
                    Voltar
                  </ButtonShared>
                </Wrapper>
              </ContainerModal>
            )}
          </AnimatePresence>
        </Modal>
      )}
    </>
  );
};
